export default __webpack_public_path__ + "static/media/matching-profiles.15efb8d9.svg";